import { ChangeEventHandler, FC, useCallback, useMemo, useState } from 'react'
import { getGameThumbnail, imgOnError, useToken } from '@utilities/helpers'
import GameLobbyLayout from '@layouts/GameLobbyLayout'
import Input from '@components/form/Input'
import Button, { ButtonTypes } from '@components/Button'
import debounce from 'lodash.debounce'
import { getGameLink } from '@utilities/requests'
import useDevice from "../hooks/useDevice";

const games = [
  {
    name: 'Judge & Jury MegaWays',
    code: 'sw_jaj_965'
  },
  {
    name: 'Fruitopolis',
    code: 'sw_f_965'
  },
  {
    name: 'Atom Roulette',
    code: 'sw_live_erol_atom'
  },
  {
    name: 'Big Buffalo Badlands',
    code: 'sw_bbd_965'
  },
  {
    name: 'Jyn Dynasty',
    code: 'sw_jd_965'
  },
]
const GameLobby: FC = () => {
  const userToken = useToken()
  const [search, setSearch] = useState('');
  const {isMobile} = useDevice();

  const data = useMemo(() => {
    if (search) {
      const searchLowerCase = search.toLowerCase()
      return games.filter((game) => game.name.toLowerCase().includes(searchLowerCase) || game.code.toLowerCase().includes(searchLowerCase))
    }
    return games
  }, [games, search])

  const onSearch = useCallback<ChangeEventHandler<HTMLInputElement>>((e) => {
    setSearch(e.target.value || '')
  }, [])
  function openTab(url: string) {
    let newWindow = window.open(url, '_blank');
    if (newWindow) {
      newWindow.opener = null
    } else {
      window.location.assign(url)
    }
  }
  const openGame = (gameId: string) => async () => {
    const gameLink = await getGameLink(userToken, gameId)
    if (gameLink) {
      openTab(gameLink)
    }
  }

  return (
    <GameLobbyLayout>
      {/*<form className="game-lobby--search">*/}
      {/*  <Input placeholder="Search for games..." onChange={debounce(onSearch, 100)}/>*/}
      {/*  <Button disabled={search === ''} className="btn-search" type={ButtonTypes.Submit} onClick={() => {*/}
      {/*  }}>Search</Button>*/}
      {/*</form>*/}
      <div className='game-lobby-description'>
        <p style={{fontSize: "2em"}} className='game-lobby-description-title'>
          Get ready to boogie down for some great prizes.
        </p>
        <br/>
        <p className='game-lobby-description--blue'>The rules are simple; groove, shimmy, and shake your way up
          <br/>
          the Disco Mania Megawaysm Merged leaderboard for the chance at a top 3 prize.
          <br/>
          Here's some funky fresh news: you might win a Lucky Envelope just by participating.
        </p>
        <br/>
        <p className='game-lobby-description--purple'>Play starts on July 11, 2022 at 10am (CET). Enjoy the day, and best of luck!</p>
      </div>
      <div className="game-lobby--body">
        {data.map((game, idx) => (
          <div key={idx} onClick={openGame(game.code)} className="game-lobby--body-item"
               // style={{backgroundImage: `url('${getGameThumbnail(game.code)}')`}}
          >
            <img onError={imgOnError} src={getGameThumbnail(game.code, true)} alt="game-thumb"/>
            {/*<div>{game.name}</div>*/}
          </div>
        ))}
      </div>
    </GameLobbyLayout>
  )
}

export default GameLobby
